import { render, staticRenderFns } from "./EditCalendarModal.vue?vue&type=template&id=407c10f2"
import script from "./EditCalendarModal.vue?vue&type=script&lang=js"
export * from "./EditCalendarModal.vue?vue&type=script&lang=js"
import style0 from "./EditCalendarModal.vue?vue&type=style&index=0&id=407c10f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports